const UserHome = () => import(/* webpackChunkName: "userHome" */ '@/pages/user/UserHome.vue')
const routes = [
    {
        path: '/users',
        component: UserHome,
        meta: { breadCrumb: 'Users', entity: 'editUsers' },
        children: [
            {
                path: '',
                name: 'users',
                component: () => import('@/pages/user/List.vue'),
            },
            {
                path: ':id',
                name: 'editUser',
                component: () => import('@/pages/user/Editor.vue'),
                props: true,
                meta: { breadCrumb: 'Edit' },
            },
        ],
    },
]

export default routes
